/* eslint-disable react/prop-types */
import React, { Fragment } from "react"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Modal,
    Container,
    CardText,
} from "reactstrap"
import { SpribeModalTable } from "./SpribeModalTable"
export const SpribeLargeModal = props => {

    const {
        data,
        columns,
        isOpen,
        size,
        setIsOpen,
    } = props


    return (
        <Fragment>
            <div>
                <Modal
                    size={size}
                    isOpen={isOpen}
                    centered
                >
                    <div
                        className="modal-header"
                        style={{ backgroundColor: "#f5f5f5", color: "black" }}
                    >
                        <h5 className="modal-title mt-0" id="myExtraLargeModalLabel">
                            Action ID - {data[0]?.action_id}
                        </h5>
                        <button
                            onClick={() => {
                                setIsOpen(false)
                            }}
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <Row>
                            <Col lg={12}>
                                <SpribeModalTable
                                    size={size}
                                    columns={columns}
                                    data={data}
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className="modal-footer" style={{ backgroundColor: "#f5f5f5" }}>
                        <div className="row w-100">
                            <div className="col-lg-6"></div>
                            <div className="col-lg-6">
                                <div className="d-flex" style={{float: "right"}}>
                                    <div
                                        style={{
                                            padding: "10px",
                                            backgroundColor: "#ff385e",
                                            color: "white",
                                        }}
                                        onClick={() => {
                                            setIsOpen(false)
                                        }}
                                    >
                                        Close
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        </Fragment>
    )
}
